module.exports = __webpack_public_path__ + "static/jll-hotel-cad68cdf7c793c334f56de05ac85b94b.png";